import { PropsWithChildren } from "react";
import { Container, Stack } from "@mui/material";
import ListPageHeader from "./header";

interface ListPageProps extends PropsWithChildren {
    wide?: boolean;
    noPaddingBottom?: boolean;
}

export function ListPage({
    children,
    wide = false,
}: ListPageProps) {
    return (
        <Container
            maxWidth={wide ? false : 'xl'}
            component={Stack}
            flex={1}
            paddingY={3}
            sx={{
                ...(wide && {
                    maxWidth: '95% !important',
                    '@media (min-width: 1920px)': {
                        maxWidth: '1800px !important'
                    }
                })
            }}
        >
            {children}
        </Container>
    )
}

ListPage.Header = ListPageHeader;